import { render } from "./DetailSplitView.vue?vue&type=template&id=334054f8&scoped=true"
import script from "./DetailSplitView.vue?vue&type=script&lang=js"
export * from "./DetailSplitView.vue?vue&type=script&lang=js"

import "./DetailSplitView.vue?vue&type=style&index=0&id=334054f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334054f8"]])

export default __exports__